import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
//
//
//
//
//
export default {
  props: {
    autoClick: {
      type: Boolean
    },
    countDown: {
      type: Number
    }
  },
  created: function created() {
    var _this = this;

    if (this.autoClick) {
      setTimeout(function () {
        _this.$emit('click');
      }, this.countDown);
    }
  }
};